var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1122 0C5.55506 0 0.25 5.37 0.25 12C0.25 18.63 5.55506 24 12.1122 24C18.6693 24 23.9863 18.63 23.9863 12C23.9863 5.37 18.6693 0 12.1122 0ZM12.1181 21.6C6.87242 21.6 2.62363 17.304 2.62363 12C2.62363 6.696 6.87242 2.4 12.1181 2.4C17.3638 2.4 21.6126 6.696 21.6126 12C21.6126 17.304 17.3638 21.6 12.1181 21.6ZM12.7115 6H10.9313V13.2L17.1562 16.98L18.0522 15.504L12.7115 12.3V6Z","fill":"#333333"}));
}

Time.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Time;

Time.default = Time;
